<template>
	<div class="skySelectInput">
		<el-input
			:style="{ width: width }"
			@blur="$emit('blur')"
			v-bind="$attrs"
			:clearable="clearable"
			type="text"
			v-model="inputValue"
			:disabled="filterOptions() ? disabled : disabled"
			@input="input"
			:placeholder="placeholder"
		>
      <el-select v-model="select" :disabled="filterOptions() ? disabled : disabled" slot="prepend" placeholder="请选择" @change="change">
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item[props.label]"
          :value="item[props.value]"
          :disabled="filterSelectOptions ? item.disabled() : item['status'] == 1"
        >
        </el-option>
      </el-select>
			<template v-slot:append v-if="unit">{{ unit }}</template>
		</el-input>
	</div>
</template>
<script>
export default {
	name: 'skySelectInput',
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: Object,
			default: () => {
				return {
					bidModifier: '',
					type: '',
					resourceName: null
				};
			},
		},
		unit: {
			type: String,
			default: ''
		},
		clearable: {
			type: Boolean,
			default: true
		},
		filterOptions: {
			type: Function,
			default: () => 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
    filterSelectOptions: {
			type: Function,
			default: null
		},
		width: {
			type: String,
			default: '100%'
		},
    options: {
			type: Array,
			default: () => [],
		},
    props: {
			type: Object,
			default: () => {
				return {
					label: 'name',
					value: 'code',
				};
			},
		},
	},
	data() {
		return {
			inputValue: this.value.bidModifier,
      select: this.value.type,
			resourceName: null
		};
	},
	methods: {
		input(val) {
			this.$emit('input', {bidModifier: val, type: this.select, resourceName: this.resourceName});
			this.$emit('change', {bidModifier: val, type: this.select, resourceName: this.resourceName});
		},
    change(val) {
			this.$emit('input', {bidModifier: this.inputValue, type: val, resourceName: this.resourceName});
			this.$emit('change', {bidModifier: this.inputValue, type: val, resourceName: this.resourceName});
		}
	},
	watch: {
		value: {
			handler(val) {
				this.inputValue = val.bidModifier;
				this.select = val.type;
				this.resourceName = val.resourceName
			},
			immediate: true
		}
	}
};
</script>
<style>
.skySelectInput .el-select{
  width: 100px;
}
</style>